import { ISavedNewAPMFileDetails } from "../aircraftDetails/index";

export enum EnumAPMSettingsTypeOfFields {
  NonEditableTextField = 0,
  EditableTextField = 1,
  ListSelection = 2,
}

export enum EnumAPMSettingsDataTypeOfFields {
  MinimumPositiveNegativeInteger = 0,
  MinimumPositiveInteger = 1,
  MinimumFloatingNumber = 2,
  MinimumNumberOfCharacters = 3,
  MinimumNumberOfCharactersSelection = 4,
  MinimumNumberOfBytes = 7,
}

export interface SelectOptions {
  [option: string]: string;
}
export interface APMSettingField {
  id: number;
  name: string;
  index: number;
  type: number;
  dataType: number;
  value: string;
  minValue: string;
  maxValue: string;
  floatResolution: number;
  numberOfOption: number;
  fieldGrouping: string | null;
  optionAvailable: SelectOptions | null;
}

export interface APMSettingsViewFields {
  apmSettings: APMSettingField[];
}

export interface IGeneratedFileStatus {
  errorInfo: string;
  message: string;
  status: string;
}

export interface IAPMSettingsState {
  savedNewAPMFileDetails: ISavedNewAPMFileDetails | null;
  saveAPMSettingsLoading: boolean;
  saveFileNameModalOpen: boolean;
  updatedAPMSettingsDetails: APMSettingField[] | null;
  generateFileNameLoading: boolean;
  GeneratedFileName: IGeneratedFileStatus | null;
  generateFileNameSaveStatus: boolean;
  checkFileNameLoading: boolean;
  isFileNameExist: boolean | null;
}
